// import { PERMISSIONS_SUBSCRIBED_PLAN } from 'constants/permissions';
import { SCOPES } from 'constants/roles';

export default [
  {
    type: 'section',
    name: 'invitations-list',
    scope: SCOPES.INSTANCE_STAFF,
    label: 'label.invitations',
    navigationIcon: 'far fa-envelope',
    url: '/professional/persons/invitations',
  },
];



// WEBPACK FOOTER //
// ./src/data/navigations/person/navigation-person-invitation.js